import { IoIosLink,IoIosShareAlt } from "react-icons/io";
const ShareButton = ({ title, text, url }) => {
    const handleShare = async () => {
      if (navigator.share) {
        try {
          await navigator.share({ 
            url,
          });
          console.log("Content shared successfully");
        } catch (error) {
        
        }
      } else {
      
      }
    };
  
    return <IoIosShareAlt title="Share" className='share-link' onClick={handleShare} />;
  };
  
  export default ShareButton;
  